import React, { FunctionComponent, ReactNode, useContext } from 'react';
import { Colors } from 'ui/styles/utils/colors';
import { ModalContext } from 'ui/molecules/modal/provider';
import * as Styled from './styled';

interface ModalHeaderProps {
  disableClose?: boolean;
  iconColor?: Colors;
  overlap?: boolean;
  className?: string;
  children: ReactNode;
}

export const ModalHeader: FunctionComponent<ModalHeaderProps> = ({
  children,
  iconColor = 'grayDark',
  overlap,
  className,
}) => {
  const { disableClose, onClose } = useContext(ModalContext);

  function closeButton() {
    return (
      <Styled.CloseIcon name="close-thin" size="large" color={iconColor} onClick={onClose} disabled={disableClose} />
    );
  }

  return (
    <Styled.ModalHeader $overlap={overlap} className={className}>
      {children}
      {closeButton()}
    </Styled.ModalHeader>
  );
};

export default ModalHeader;
